<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p24"><span><a href="#/Contents#rp24">ZUCCHINI SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="49" src="images/45ref.jpg" width="25"/></span></p>
<p class="normal"><span><i>Make this soup when your garden is overflowing with zucchini!</i></span></p>
<p class="make"><span>4 first-course servings</span></p>
<p class="hang"><span>2 cups each: reduced-sodium fat-free chicken broth, sliced zucchini</span></p>
<p class="hang"><span>1 cup chopped onion</span></p>
<p class="hang"><span>3 cloves garlic, minced</span></p>
<p class="hang"><span>1 tablespoon tarragon vinegar</span></p>
<p class="hang"><span>1 teaspoon curry powder</span></p>
<p class="hang"><span>½ teaspoon dried marjoram leaves</span></p>
<p class="hang"><span>⅛ teaspoon celery seeds</span></p>
<p class="hang"><span>1 cup fat-free plain yogurt</span></p>
<p class="hang"><span>Salt and cayenne pepper, to taste</span></p>
<p class="hang"><span>Paprika, as garnish</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients, except yogurt, salt, cayenne pepper, and paprika, to boiling in medium saucepan; reduce heat and simmer, covered, until vegetables are tender, about 8 minutes. Process soup and yogurt in food processor or blender until smooth; season to taste with salt and cayenne pepper. Refrigerate until chilled; sprinkle each bowl of soup with paprika.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 84</span></p>
<p class="per1"><span>% calories from fat: 4</span></p>
<p class="per1"><span>Protein (g): 8.5</span></p>
<p class="per1"><span>Carbohydrate (g): 11.9</span></p>
<p class="per1"><span>Fat (g): 0.4</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 1.4</span></p>
<p class="per1"><span>Sodium (mg): 144</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.5</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter026.vue?16d78abc